// ============================================================================
// CONGOLESE (LINGALA) TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Bomengo ya molimo oyo euti na Liloba

export const bibleTreasuresRc = [
  {
    type: "perle_sagesse",
    content: "Bwanya ya bosantu ezali theorie ya makanisi te, kasi ezali bomoi ya solo oyo emonanaka na maponi na biso ya mokolo na mokolo",
    reference: "Masese 3:13-18",
    category: "Bwanya",
    strongNumbers: {
      "bwanya": "H2451", // חָכְמָה (chokmah) = bwanya ya mosala
      "boyebi": "H8394" // תְּבוּנָה (tebunah) = kososolaka malamu
    },
    reflection: "Ndenge nini nakoki kosalela bwanya ya Nzambe na maponi na ngai lelo?"
  },
  {
    type: "tresor_divine",
    content: "Bolingo ya Nzambe ezali na mabongisi ya makambo oyo tosali te, kasi ezali likabo ya seko oyo eutiaka na bomoi ya Nzambe moko",
    reference: "Baroma 8:38-39",
    category: "Bolingo",
    strongNumbers: {
      "bolingo": "G26", // ἀγάπη (agape) = bolingo ya kondima te
      "kokabwana": "G5563" // χωρίζω (chorizo) = kokabola
    },
    reflection: "Eloko moko te ekoki kokabola biso na bolingo ya Nzambe oyo emonanaki na Klisto"
  },
  {
    type: "lumiere_vie",
    content: "Yesu azali kaka nzela na biso te, kasi pole oyo ezali kongenga kati na biso",
    reference: "Yoane 8:12",
    category: "Bomoi",
    strongNumbers: {
      "pole": "G5457", // φῶς (phos) = pole
      "bomoi": "G2222" // ζωή (zoe) = bomoi ya bofuluki
    },
    reflection: "Ndenge nini natika pole ya Klisto angenga bisika ya molili na ngai?"
  },
  {
    type: "force_divine",
    content: "Nguya na biso eutiaka na biso moko te, kasi eutiaka na oyo afandaka kati na biso",
    reference: "Ba-Efeso 3:16-17",
    category: "Nguya",
    strongNumbers: {
      "kopesa makasi": "G2901", // κραταιόω (krataioo) = kopesa makasi
      "nguya": "G1411" // δύναμις (dynamis) = nguya ya nzambe
    },
    reflection: "Nazali kotia motema na nguya ya Nzambe na ntango ya bolema na ngai?"
  },
  {
    type: "paix_profonde",
    content: "Kimia ya Nzambe etalelaka makambo ya libanda te, kasi etalelaka bozali ya Nzambe ya tango nyonso na mitema na biso",
    reference: "Bafilipo 4:6-7",
    category: "Kimia",
    strongNumbers: {
      "kimia": "G1515", // εἰρήνη (eirene) = kimia mobimba
      "kobatela": "G5432" // φρουρέω (phroureo) = kobatela lokola engumba"
    },
    reflection: "Ndenge nini nakoki kolona kimia ya Nzambe oyo eleki bososoli nyonso?"
  },
  {
    type: "esperance_vivante",
    content: "Elikya na biso ezali mposa ya kokanisa te, kasi ezali nkusa ya makasi oyo ezali na ntina ya bilaka ya Nzambe oyo ekobalukaka te",
    reference: "Baebele 6:19",
    category: "Elikya",
    strongNumbers: {
      "elikya": "G1680", // ἐλπίς (elpis) = elikya ya kondima
      "nkusa": "G45" // ἄγκυρα (ankyra) = nkusa ya molimo
    },
    reflection: "Na elaka nini ya Nzambe nakotia nkusa ya elikya na ngai lelo?"
  },
  {
    type: "transformation",
    content: "Mbongwana ya molimo ezali mosala ya tango nyonso, mpe tozali kokóma mokolo na mokolo lokola elilingi ya Klisto",
    reference: "2 Bakorinto 3:18",
    category: "Bokoli",
    strongNumbers: {
      "kobongwana": "G3339", // μεταμορφόω (metamorphoo) = kobongwana mobimba
      "nkembo": "G1391" // δόξα (doxa) = nkembo ya nzambe
    },
    reflection: "Esika nini ya bomoi na ngai esengaka mbongwana lelo?"
  }
];

export default bibleTreasuresRc;
